(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tr-article-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tr-article-share')) {
    customElements.define('tr-article-share', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelector('button').addEventListener('click', async () => {
          const input = this.querySelector('input');
          try {
            await navigator.clipboard.writeText(input.value);
            this.querySelector('[role=status]').textContent = this.dataset.success;
          } catch {
            input.focus();
            input.select();
          }
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          this.querySelector('details').open = false;
          this.querySelector('summary').focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
